import { userStore } from '@/store';

/**
 * ログインIDがkokopelliかどうか
 */
export const isLoginIdKokopelli = (): boolean => {
  return userStore.loginUser.user_login_id === 'kokopelli';
};
